
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import Breadcrumb from '../../components/feature/Breadcrumb';

export default function FuncionalidadesPage() {
  const features = [
    {
      icon: 'ri-file-text-line',
      title: 'Emissão de CT-e e MDF-e',
      slug: 'cte-mdfe',
      description: 'Sistema para emitir CT-e e MDF-e online de forma rápida, segura e sem complicação. Emissor de CT-e integrado com SEFAZ',
      benefits: [
        'Emissor de CT-e completo e certificado',
        'Emissão de MDF-e automática',
        'Programa para emissão de CT-e validado',
        'Conformidade com a legislação fiscal',
      ],
      color: 'primary',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Controle Financeiro',
      slug: 'financeiro',
      description: 'Software de gestão de transportes com controle completo de custos, despesas e fluxo de caixa da sua transportadora',
      benefits: [
        'Controle detalhado de custos por veículo',
        'Gestão de despesas e orçamentos',
        'Organização por centro de custos',
        'Fluxo de caixa completo',
      ],
      color: 'secondary',
    },
    {
      icon: 'ri-archive-line',
      title: 'Gestão de Estoque',
      slug: 'estoque',
      description: 'Sistema completo para transportadora com controle total de peças, insumos e custos de manutenção',
      benefits: [
        'Controle de peças e insumos',
        'Gestão de entradas e saídas',
        'Custos de manutenção',
        'Evite perdas e desperdícios',
      ],
      color: 'primary',
    },
    {
      icon: 'ri-user-star-line',
      title: 'Cadastro de Motoristas',
      slug: 'motorista',
      description: 'Software para transportadora com gestão completa de documentação e histórico operacional dos motoristas',
      benefits: [
        'Cadastro completo de documentação',
        'Controle de CNH e vencimentos',
        'Histórico operacional',
        'Vínculo com veículos e viagens',
      ],
      color: 'secondary',
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Relatórios Gerenciais',
      slug: 'relatorios',
      description: 'Sistema para gestão de frota com indicadores estratégicos e relatórios inteligentes para tomada de decisão',
      benefits: [
        'Rentabilidade por veículo',
        'Custos por centro de custos',
        'Desempenho financeiro',
        'Indicadores em tempo real',
      ],
      color: 'primary',
    },
    {
      icon: 'ri-cloud-line',
      title: '100% na Nuvem',
      slug: 'nuvem',
      description: 'Melhor software para transportadora: acesse de qualquer lugar, a qualquer momento, com total segurança',
      benefits: [
        'Acesso de qualquer dispositivo',
        'Segurança de dados',
        'Backup automático',
        'Atualizações constantes',
      ],
      color: 'secondary',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-24 sm:pt-28 lg:pt-32 pb-12 sm:pb-16 lg:pb-20 bg-gradient-to-br from-primary via-primary-700 to-primary-900 text-white">
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Breadcrumb
            items={[
              { label: 'Início', href: '/' },
              { label: 'Funcionalidades' },
            ]}
          />
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6">
            Funcionalidades do Sistema
          </h1>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-neutral-100 max-w-3xl mx-auto leading-relaxed px-2">
            Conheça todas as funcionalidades do nosso <strong>software para transportadora</strong>: desde a <strong>emissão de CT-e online</strong> até a gestão completa da sua frota
          </p>
        </div>
      </section>

      {/* SEO Content Section */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-neutral-900 mb-3 sm:mb-4">
              Por Que Escolher Nosso Sistema?
            </h2>
            <p className="text-sm sm:text-base lg:text-lg text-neutral-700 max-w-4xl mx-auto leading-relaxed px-2">
              O TG WEB é um <strong>sistema completo para transportadora de cargas</strong> que oferece todas as ferramentas necessárias para gerenciar sua operação. 
              Nosso <strong>programa para emissão de CT-e</strong> é integrado com um poderoso <strong>software de gestão de transportes</strong>, 
              proporcionando controle total desde a <strong>emissão de CT-e</strong> e <strong>MDF-e</strong> até relatórios gerenciais avançados.
            </p>
          </div>
        </div>
      </section>

      {/* Features Grid */}
      <section className="py-16 sm:py-20 lg:py-24 bg-neutral-50">
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
            {features.map((feature, index) => (
              <Link
                key={index}
                to={`/funcionalidades/${feature.slug}`}
                className="group bg-white p-5 sm:p-6 lg:p-8 rounded-2xl shadow-card hover:shadow-hover transition-all cursor-pointer border border-neutral-100"
              >
                <div className={`w-12 h-12 sm:w-14 lg:w-16 sm:h-14 lg:h-16 flex items-center justify-center bg-${feature.color}/10 rounded-xl mb-4 sm:mb-6 group-hover:bg-${feature.color}/20 transition-colors`}>
                  <i className={`${feature.icon} text-2xl sm:text-3xl lg:text-4xl text-${feature.color}`}></i>
                </div>
                
                <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-neutral-900 mb-2 sm:mb-4 group-hover:text-primary transition-colors">
                  {feature.title}
                </h3>
                
                <p className="text-neutral-600 mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base">
                  {feature.description}
                </p>

                <ul className="space-y-2 sm:space-y-3 mb-4 sm:mb-6">
                  {feature.benefits.map((benefit, idx) => (
                    <li key={idx} className="flex items-start text-xs sm:text-sm text-neutral-700">
                      <i className="ri-check-line text-secondary mr-2 mt-0.5 flex-shrink-0"></i>
                      <span>{benefit}</span>
                    </li>
                  ))}
                </ul>

                <div className="flex items-center text-primary font-semibold text-sm group-hover:translate-x-2 transition-transform">
                  Saiba mais
                  <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-neutral-900 mb-3 sm:mb-4">
              Vantagens do Nosso Software
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">
            <div className="flex items-start space-x-3 sm:space-x-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-primary/10 rounded-lg flex-shrink-0">
                <i className="ri-file-check-line text-xl sm:text-2xl text-primary"></i>
              </div>
              <div>
                <h3 className="text-lg sm:text-xl font-bold text-neutral-900 mb-1 sm:mb-2">Emissor de CT-e Certificado</h3>
                <p className="text-neutral-600 text-sm sm:text-base">
                  Nosso <strong>sistema para emissão de CT-e</strong> é homologado pela SEFAZ e garante conformidade fiscal total.
                </p>
              </div>
            </div>
            <div className="flex items-start space-x-3 sm:space-x-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-secondary/10 rounded-lg flex-shrink-0">
                <i className="ri-truck-line text-xl sm:text-2xl text-secondary"></i>
              </div>
              <div>
                <h3 className="text-lg sm:text-xl font-bold text-neutral-900 mb-1 sm:mb-2">Gestão de Frota Completa</h3>
                <p className="text-neutral-600 text-sm sm:text-base">
                  <strong>Sistema para gestão de frota</strong> com controle de veículos, motoristas, manutenções e custos.
                </p>
              </div>
            </div>
            <div className="flex items-start space-x-3 sm:space-x-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-primary/10 rounded-lg flex-shrink-0">
                <i className="ri-money-dollar-circle-line text-xl sm:text-2xl text-primary"></i>
              </div>
              <div>
                <h3 className="text-lg sm:text-xl font-bold text-neutral-900 mb-1 sm:mb-2">Controle Financeiro Total</h3>
                <p className="text-neutral-600 text-sm sm:text-base">
                  <strong>Software de gestão de transportes</strong> com controle de contas a pagar e receber, fluxo de caixa e relatórios.
                </p>
              </div>
            </div>
            <div className="flex items-start space-x-3 sm:space-x-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-secondary/10 rounded-lg flex-shrink-0">
                <i className="ri-cloud-line text-xl sm:text-2xl text-secondary"></i>
              </div>
              <div>
                <h3 className="text-lg sm:text-xl font-bold text-neutral-900 mb-1 sm:mb-2">100% na Nuvem</h3>
                <p className="text-neutral-600 text-sm sm:text-base">
                  O <strong>melhor software para transportadora</strong> é online: acesse de qualquer lugar, sem instalação.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 sm:py-20 lg:py-24 bg-gradient-to-br from-secondary via-secondary-500 to-secondary-600 text-white">
        <div className="w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6">
            Teste Nosso Sistema
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-white/90 mb-6 sm:mb-10 leading-relaxed px-2">
            Experimente gratuitamente por 14 dias nosso <strong>software para transportadora</strong> com <strong>emissão de CT-e online</strong> e todas as funcionalidades
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
            <a
              href="https://wa.me/5511999999999?text=Olá,%20gostaria%20de%20conhecer%20o%20sistema%20para%20transportadora%20TG%20WEB"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-white text-secondary text-base sm:text-lg font-semibold rounded-lg hover:bg-neutral-100 transition-all shadow-hover whitespace-nowrap cursor-pointer text-center"
            >
              Fale com um Especialista
            </a>
            <Link
              to="/planos"
              className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-white/10 backdrop-blur-sm text-white text-base sm:text-lg font-semibold rounded-lg hover:bg-white/20 transition-all border border-white/30 whitespace-nowrap text-center"
            >
              Ver Planos
            </Link>
          </div>
        </div>
      </section>

      {/* Related Links Section */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h3 className="text-xl sm:text-2xl font-bold text-neutral-900 mb-6 sm:mb-8 text-center">
            Saiba Mais Sobre o TG WEB
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
            <div className="bg-neutral-50 p-5 sm:p-6 rounded-xl border border-neutral-100">
              <h4 className="font-bold text-neutral-900 mb-3 sm:mb-4 flex items-center text-sm sm:text-base">
                <i className="ri-price-tag-3-line text-secondary mr-2"></i>
                Planos e Preços
              </h4>
              <p className="text-xs sm:text-sm text-neutral-600 mb-3 sm:mb-4">
                Escolha o plano ideal para sua transportadora, desde pequenas frotas até grandes operações.
              </p>
              <Link
                to="/planos"
                className="inline-flex items-center text-primary font-semibold text-xs sm:text-sm hover:text-primary-700 transition-colors"
              >
                Ver planos disponíveis
                <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>

            <div className="bg-neutral-50 p-5 sm:p-6 rounded-xl border border-neutral-100">
              <h4 className="font-bold text-neutral-900 mb-3 sm:mb-4 flex items-center text-sm sm:text-base">
                <i className="ri-file-text-line text-secondary mr-2"></i>
                Emissor de CT-e
              </h4>
              <p className="text-xs sm:text-sm text-neutral-600 mb-3 sm:mb-4">
                Guia completo sobre como funciona a emissão de CT-e e MDF-e online no TG WEB.
              </p>
              <Link
                to="/sistema-emissao-cte"
                className="inline-flex items-center text-primary font-semibold text-xs sm:text-sm hover:text-primary-700 transition-colors"
              >
                Saiba como emitir CT-e
                <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>

            <div className="bg-neutral-50 p-5 sm:p-6 rounded-xl border border-neutral-100">
              <h4 className="font-bold text-neutral-900 mb-3 sm:mb-4 flex items-center text-sm sm:text-base">
                <i className="ri-question-answer-line text-secondary mr-2"></i>
                Dúvidas Frequentes
              </h4>
              <p className="text-xs sm:text-sm text-neutral-600 mb-3 sm:mb-4">
                Encontre respostas para as principais dúvidas sobre o sistema para transportadora.
              </p>
              <Link
                to="/faq"
                className="inline-flex items-center text-primary font-semibold text-xs sm:text-sm hover:text-primary-700 transition-colors"
              >
                Ver perguntas frequentes
                <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>
          </div>

          {/* Blog Posts Links */}
          <div className="mt-8 sm:mt-12 pt-6 sm:pt-8 border-t border-neutral-200">
            <h4 className="font-bold text-neutral-900 mb-3 sm:mb-4 text-center text-sm sm:text-base">
              Artigos Relacionados no Blog
            </h4>
            <div className="flex flex-wrap justify-center gap-3 sm:gap-4 text-xs sm:text-sm">
              <Link to="/blog" className="text-neutral-600 hover:text-primary transition-colors">
                Gestão de Frotas
              </Link>
              <span className="text-neutral-300 hidden sm:inline">•</span>
              <Link to="/blog" className="text-neutral-600 hover:text-primary transition-colors">
                Documentos Fiscais
              </Link>
              <span className="text-neutral-300 hidden sm:inline">•</span>
              <Link to="/blog" className="text-neutral-600 hover:text-primary transition-colors">
                Controle Financeiro
              </Link>
              <span className="text-neutral-300 hidden sm:inline">•</span>
              <Link to="/blog" className="text-neutral-600 hover:text-primary transition-colors">
                Tecnologia
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
